<template>
  <div class="admin-products">
    <h1>商品管理</h1>

    <!-- 查詢、篩選區塊 -->
    <div class="filter-section">
      <input
        v-model="searchKeyword"
        type="text"
        placeholder="輸入商品關鍵字..."
        @keyup.enter="handleSearch"
      />

      <!-- 類別篩選 -->
      <select v-if="product_types" v-model="selectedProductType">
        <option value="">全部類別</option>
        <option
          v-for="typeItem in product_types"
          :key="typeItem.id"
          :value="typeItem.id"
        >
          {{ typeItem.type_name }}
        </option>
      </select>

      <button @click="handleSearch">搜尋</button>
      <button @click="openCategoryModal">商品類別</button>
      <button @click="openNewProductModal">新增商品</button>
    </div>

        <!-- 簡易分頁功能 -->
    <div class="pagination">
      <button @click="prevPage" :disabled="currentPage <= 1">
        上一頁
      </button>
      <span>目前頁次：{{ currentPage }} / {{ totalPages }}</span>
      <button @click="nextPage" :disabled="currentPage >= totalPages">
        下一頁
      </button>
    </div>

    <!-- 商品列表 Table -->
    <div class="table-responsive">
      <table class="products-table">
      <thead>
        <tr>
          <th>狀態</th>
          <th>展示</th>
          <th>商品名稱</th>
          <th>類別</th>
          <th>庫存</th>
          <th>已售</th>
          <th>觀看</th>
          <th>商品ID</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(product) in products" :key="product.product_id">
          <td>
            <label class="checkbox-label">
              <label class="switch">
              <input
                type="checkbox"
                v-model="product.is_active"
                :true-value="1"
                :false-value="0"
                 @change="updateIsActive(product)"
              />
              <span class="slider"></span>
              </label>
              <span class="check-label">
                {{ product.is_active == 1 ? '上架' : '下架' }}
              </span>
            </label>
          </td>
       
          <td><img :src="product.image_url" alt="商品圖片" style="width: 50px; height: 50px;" /></td>
          <td>{{ product.title }}</td>
          <td>{{ getProductTypeName(product.product_type) }}</td>
          <td>{{ product.stock }}</td>
          <td>{{ product.sold_quantity }}</td>
          <td>{{ product.views_count }}</td>
          <td>{{ product.product_id }}</td>
          <td>
            <button @click="editHtml(product.product_id)">詳細</button>
            <button @click="editProduct(product)">編輯</button>
            <button @click="deleteProduct(product.product_id)">刪除</button>
           
          </td>
        </tr>
      </tbody>
    </table>
  </div>


  <!-- Modal：用於「新增 / 編輯」商品 -->
  <!-- ########################  商品管理 Modal ######################## -->
  <div class="modal-backdrop" v-if="showModal">
    <div class="modal product-modal">
      <h2>{{ currentEditProduct ? '編輯商品' : '新增商品' }}</h2>

      <!-- (A) 基本商品資訊區塊 -->
      <div class="product-basic-info">
      <!-- 【新增】SEO 敘述欄位 -->
      <div class="form-group">
        <label>請輸入SEO描述 ( 建議50~160字)  
          <span v-if="formErrors.seo_description" class="error-message">
            {{ formErrors.seo_description }}
          </span>
        </label>
        <input
          style="font-size: 12px;"
          v-model="form.seo_description"
          :class="{ 'is-invalid': formErrors.seo_description }"
          type="text"
        />
      </div>

        <div class="multi-fields">

  <!-- 分類 -->
  <div class="sub-field">
    <label>分類  <span v-if="formErrors.product_type" class="error-message">{{ formErrors.product_type }}</span></label>
    <select v-model="form.product_type" :class="{ 'is-invalid': formErrors.product_type }">
      <option value="">請選擇分類</option>
      <option
        v-for="typeItem in product_types"
        :key="typeItem.id"
        :value="typeItem.id"
      >
        {{ typeItem.type_name }}
      </option>
    </select>
  </div>

  <!-- 商品名稱 -->
  <div class="sub-field">
    <label>商品名稱 <span v-if="formErrors.title" class="error-message">{{ formErrors.title }}</span>
     </label>
    <input
      v-model="form.title" :class="{ 'is-invalid': formErrors.title }"
      type="text"
      placeholder="如：璀璨之祕面膜（舒緩保濕 )"
    />
  </div>

  <!-- 商品描述 -->
  <div class="sub-field">
    <label>商品描述 <span v-if="formErrors.description" class="error-message">{{ formErrors.description }}</span>

    </label>
    <textarea
      v-model="form.description" :class="{ 'is-invalid': formErrors.description }"
      rows="2"
      placeholder="簡要說明商品功能 / 特色 (18字內)"
    ></textarea>
  </div>
</div>
  <!-- 第一行：單位 + 觀看數 -->
  <div class="two-cols" style="margin-bottom: 1rem;">
    <div class="sub-field">
      <label>單位 <span v-if="formErrors.unit" class="error-message">{{ formErrors.unit }}</span>

      </label>
      <input v-model="form.unit" type="text" 
      :class="{ 'is-invalid': formErrors.unit }"
      placeholder="片 / 盒 / 瓶" />
    </div>
    <div class="sub-field">
      <label>觀看數 <span v-if="formErrors.views_count" class="error-message">{{ formErrors.views_count }}</span>

      </label>
      <input v-model.number="form.views_count" 
      :class="{ 'is-invalid': formErrors.views_count }"
      type="number" min="0" />
    </div>
  </div>

  <!-- 第二行：數量 + 已售 -->
  <div class="two-cols">
    <div class="sub-field">
      <label>庫存 <span v-if="formErrors.stock" class="error-message">{{ formErrors.stock }}</span>

      </label>
      <input v-model.number="form.stock" 
      :class="{ 'is-invalid': formErrors.stock }"
      type="number" min="0" />
    </div>
    <div class="sub-field">
      <label>已售 <span v-if="formErrors.sold_quantity" class="error-message">{{ formErrors.sold_quantity }}</span>

      </label>
      <input v-model.number="form.sold_quantity"
      :class="{ 'is-invalid': formErrors.sold_quantity }"
       type="number" min="0" />
    </div>
  </div>
        <div class="form-group">
          <label>商品主圖 1378 x 1188 (URL) <span v-if="formErrors.image_url" class="error-message">{{ formErrors.image_url }}</span>
          </label>
          <input
            v-model="form.image_url"
            :class="{ 'is-invalid': formErrors.image_url }"
            type="text"
            placeholder="https://example.com/xxx.jpg"
          />
        </div>

<!-- 這整塊就是四個 checkbox + 圖片預覽 -->
<div class="check-group" style="display: flex; align-items: flex-start;">
  <!-- 左邊：四個checkbox -->
  <div class="checkbox-list">
    <label class="checkbox-label">
      <label class="switch">
      <input
        type="checkbox"
        v-model="form.is_new"
        :true-value="1"
        :false-value="0"
      />
      <span class="slider"></span>
    </label>
      <span class="check-label">
        新品上市
      </span>
    </label>

    <label class="checkbox-label">
      <label class="switch">
      <input
        type="checkbox"
        v-model="form.is_hot"
        :true-value="1"
        :false-value="0"
      />
      <span class="slider"></span>
    </label>
      <span class="check-label">熱門商品</span>
    </label>

    <label class="checkbox-label">
      <label class="switch">
      <input
        type="checkbox"
        v-model="form.is_manager"
        :true-value="1"
        :false-value="0"
      />
      <span class="slider"></span>
    </label>
      <span class="check-label">店長推薦</span>
    </label>

    <label class="checkbox-label">
      <label class="switch">
      <input
        type="checkbox"
        v-model="form.is_active"
        :true-value="1"
        :false-value="0"
      />
      <span class="slider"></span>
      </label>
      <span class="check-label">
        {{ form.is_active == 1 ? '上架' : '下架' }}
      </span>
    </label>
  </div>

  <!-- 右邊：商品圖預覽 -->
  <div class="image-preview" v-if="form.image_url">
    <img :src="form.image_url" alt="商品預覽" />
  </div>
</div>


      </div>

      <hr />

      <!-- (B) 商品媒體管理區 -->
      <div class="">
        <!-- 左側：媒體管理 -->
        <div class="product-media">
          <h3>商品媒體</h3>
          <p class="hint">可加入圖片/YouTube 連結，並設定排序與啟用 <br>
            範例 : https://www.youtube.com/watch?v=QapG4vDaR8M <br>
            範例 1378 x 1188 : https://images.tgame.org/000.webp <br>
          </p>
          <!--顯示媒體 圖片 與 影片清單-->
          <table class="media-table">
            <thead>
              <tr>
                <th>資源 URL</th>
                <th>排序</th>
                <th>啟用</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr 
                v-for="(media, index) in form.product_media"
                :key="index"
              >
                <td  data-label="資源 URL">
                  <input
                    v-model="media.media_url"
                    :class="{ 'is-invalid': formErrors.media_url }"
                    type="text"
                    placeholder="https://..."
                    class="media-url-input"
                  />
                </td >
                <td style="width: 60px;" data-label="排序">
                  <input
                    v-model.number="media.ordering"
                    type="number"
                    min="0"
                    :class="{ 'is-invalid': formErrors.ordering }"
                    style="width: 100%;"
                  />
                </td>
                <td data-label="啟用" >
                  <label class="switch">
                  <input
                    type="checkbox"
                    v-model="media.is_active"
                      :true-value="1"
                      :false-value="0"
                  />
                  <span class="slider"></span>
                </label>
                </td>
                <td data-label="操作">
                  <button @click="removeMedia(index)">刪除</button>
                </td>
              </tr>
            </tbody>
          </table>

          <div v-if="formErrors.media_url" class="error-message">{{ formErrors.media_url }}</div>
          <div v-if="formErrors.ordering" class="error-message">{{ formErrors.ordering }}</div>
          <button class="add-btn" @click="addMedia">+ 新增媒體</button>
          <!-- 在商品媒體區塊後面，保留你的 table 不變，只加一個預覽清單 -->
          <div class="media-preview-list">
            <div
              v-for="(media, index) in form.product_media"
              :key="'preview-'+index"
              class="media-preview-item"
            >
              <div v-if="isYouTubeURL(media.media_url)">
                <iframe
                  width="100%"  
                  height="225"
                  :src="getYouTubeEmbedURL(media.media_url)"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
              </div>
              <div v-else>
                <img
                  :src="media.media_url"
                  alt="media preview"
                  style="max-width: 100%; height: auto;"
                />
              </div>
            </div>
          </div>

        </div>

        <div class="product-variants">
          <h3>商品規格</h3>
          <p class="hint">例如幾瓶，幾片，可新增多組。</p>

          <table class="table-scroll product-variants-table">
            <thead>
              <tr>
                <th>規格名稱</th>
                <th>數量</th>
                <th>原價</th>
                <th>折扣價</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(variant, vIdx) in form.product_variants"
                :key="vIdx"
              >
                <td data-label="規格">
                  <input
                    v-model="variant.variant_name"
                    type="text"
                    :class="{ 'is-invalid': formErrors.variant_name }"
                    placeholder="如：幾瓶 / 幾片"
                  />
                </td>
                <td data-label="數量">
                  <input v-model.number="variant.quantity" type="number" min="0" :class="{ 'is-invalid': formErrors.quantity }" />
                </td>
                <td  data-label="原價">
                  <input v-model.number="variant.original_price" type="number" min="0" :class="{ 'is-invalid': formErrors.original_price }" />
                </td>
                <td  data-label="折扣價">
                  <input v-model.number="variant.discount_price" type="number" min="0" :class="{ 'is-invalid': formErrors.discount_price }" />
                </td>
                <td  data-label="操作">
                  <button @click="removeVariant(vIdx)">刪除</button>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-if="formErrors.variant_name" class="error-message">{{ formErrors.variant_name }}</div>
          <div v-if="formErrors.quantity" class="error-message">{{ formErrors.quantity }}</div>
          <div v-if="formErrors.original_price" class="error-message">{{ formErrors.original_price }}</div>
          <div v-if="formErrors.discount_price" class="error-message">{{ formErrors.discount_price }}</div>
          <button class="add-btn" @click="addVariant">+ 新增規格</button>
        </div>
      </div>

      <hr />

      <!-- (C) 按鈕區 -->
      <div v-if="errorMsg" class="error-message">{{ errorMsg }}</div>
      <div class="modal-actions">
        <button @click="handleSaveProduct">
          {{ currentEditProduct ? '更新' : '新增' }}
        </button>
        <button @click="closeModal">取消</button>
      </div>
    </div>
  </div>

    <!-- ################## 新增「類別管理」Modal################ -->
    <div class="modal-backdrop" v-if="showCategoryModal" >
      <div class="modal category-modal">
        <h2>類別管理</h2>
        <p class="category-hint">
          目前共有 <strong>{{ product_types.length }}</strong> 筆類別
        </p>

        <!-- 顯示目前類別清單 -->
        <table class="category-table">
          <thead>
            <tr>
              <th>類別名稱</th>
              <th>狀態</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(cat) in product_types" :key="cat.id">
              <td>{{ cat.type_name }}</td>
              <td>
                <label class="switch">
                <input
                  type="checkbox"
                  v-model="cat.is_active"
                  :true-value="1"
                  :false-value="0"
                  disabled
                />
                <span class="slider"></span>
                </label>
                <span class="check-label">
                  {{ cat.is_active === 1 ? '啟用' : '停用' }}
                </span>
              </td>
              <td>
                <button @click="editCategory(cat)">編輯</button>
                <button @click="removeCategory(cat)">刪除</button>
              </td>
            </tr>
          </tbody>
        </table>

        <hr class="divider" />

        <!-- 新增/編輯類別 -->
        <h3>{{ categoryForm.id ? '編輯類別' : '新增類別' }}</h3>
        <div class="form-group">
          <label>類別名稱</label>
          <input v-model="categoryForm.type_name" type="text" placeholder="請輸入類別名稱" />
        </div>

        <div class="form-group check-group">
          <label class="checkbox-label">
            <label class="switch">
              <input
                type="checkbox"
                v-model="categoryForm.is_active"
                :true-value="1"
                :false-value="0"
              />
              <span class="slider"></span> 
            </label>
            <span class="check-label">
                {{ categoryForm.is_active === 1 ? '啟用' : '停用' }}
              </span>
          </label>
        </div>
        <div class="modal-actions">
          <button @click="saveCategory">{{ categoryForm.id ? '更新' : '新增' }}</button>
          <button @click="closeCategoryModal">關閉</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import { watch , ref, onBeforeMount, onMounted, onBeforeUnmount  } from 'vue'
import { useRouter,onBeforeRouteLeave } from 'vue-router'
import axios from 'axios'
import Swal from 'sweetalert2'
import { useAdminSysTempStore } from '@/store/adminSysTempStore.js'

const useAdminSysTemp = useAdminSysTempStore()
const router = useRouter()

const product_types = ref([])
const products = ref([])

const showCategoryModal = ref(false)
const categoryForm = ref({ id: null, type_name: '', is_active: 1 })

const searchKeyword = ref('')
const selectedProductType = ref('')

//const page = ref(1)

const showModal = ref(false)
const currentEditProduct = ref(null)
const errorMsg = ref('')

const limit = ref(10)           // 每頁顯示 10 筆 
const offset = ref(0)           // 從第幾筆開始抓
const currentPage = ref(1)      // 當前頁碼
const totalPages = ref(0)       // 總頁數
const total = ref(0)            // 總筆數 (由後端回傳)


const form = ref({
  product_id: null,
  product_type: '',
  unit: '',
  title: '',
  description: '',
  image_url: '',
  stock: 0,
  sold_quantity: 0,
  views_count: 0,
  is_new: 1,
  is_hot: 0,
  is_manager: 0,
  is_active: 1,
  product_media: [],
  product_variants: [],
  seo_description: undefined,
})

const formErrors = ref({})

watch(
  () => showCategoryModal.value,
  (newVal) => {
    if (newVal) {
      // 打開彈窗時，禁止整個 body 捲動
      document.body.style.overflow = 'hidden'
    } else {
      // 關閉彈窗時，恢復原狀
      document.body.style.overflow = ''
    }
  }
)
// 監聽「新增商品 Modal」的開關
watch(
  () => showModal.value,
  (newVal) => {
    if (newVal) {
      // 開啟，禁止背景捲動
      document.body.style.overflow = 'hidden'
    } else {
      // 關閉，恢復背景捲動
      document.body.style.overflow = ''
    }
  }
)

//#######  新增 / 更新 商品 ########
async function handleSaveProduct() {
  try {
    // 清空錯誤訊息
    formErrors.value = {}

    if (form.value.seo_description == undefined) {
      formErrors.value.seo_description = '請輸入SEO描述'
    }

    if (!form.value.product_type) {
      formErrors.value.product_type = '請選擇商品分類'
    }
    // 表單驗證
    if (!form.value.title) {
      formErrors.value.title = '請輸入商品名稱'
    }
    if (!form.value.description) {
      formErrors.value.description = '請輸入商品描述'
    }
    if(!form.value.unit){
      formErrors.value.unit = '請輸入單位'
    }
    const views_count = parseInt(form.value.views_count);
    if (views_count < 0 || isNaN(views_count)) {
        formErrors.value.views_count = '請輸入觀看數'
    }
    const stock = parseInt(form.value.stock);
    if (stock < 0 || isNaN(stock)) {
      formErrors.value.stock = '請輸入庫存'
    }
    const sold_quantity = parseInt(form.value.sold_quantity);
    if (sold_quantity < 0 || isNaN(sold_quantity)) {
      formErrors.value.sold_quantity = '請輸入已售數量'
    }
    const image_url = form.value.image_url;
    if (image_url === '' || !image_url.startsWith('http')) {
      formErrors.value.image_url = '請輸入有效的商品主圖 (必須以 http 開頭)';
    }
    if(form.value.product_media.length === 0){
      formErrors.value.media_url = '請新增商品媒體'
    }
    if (form.value.product_media.some(media => !media.media_url || !media.media_url.startsWith('http'))) {
        formErrors.value.media_url = '請輸入有效的媒體資源 URL (必須以 http 開頭)';
      }
      
    if (form.value.product_media.some(media => media.ordering === null || media.ordering === '' || media.ordering === undefined || media.ordering < 0 || isNaN(media.ordering))) {
      formErrors.value.ordering = '請輸入有效的排序 (必須大於或等於 0)';
    }
    if(form.value.product_variants.length === 0){
      formErrors.value.variant_name = '請新增商品規格'
    }
    if (form.value.product_variants.some(variant => !variant.variant_name)) {
      formErrors.value.variant_name = '請輸入規格名稱'
    }
    if (form.value.product_variants.some(variant => variant.quantity === "" || variant.quantity === null || variant.quantity <= 0 || isNaN(variant.quantity))) {
      formErrors.value.quantity = '請輸入有效的數量 (必須大於 0)';
    }
    // if (form.value.product_variants.some(variant => !variant.original_price)) {
    //   formErrors.value.original_price = '請輸入原價'
    // }
    // if (form.value.product_variants.some(variant => !variant.discount_price)) {
    //   formErrors.value.discount_price = '請輸入折扣價'
    // }
    // if (form.value.product_variants.some(variant => variant.original_price < variant.discount_price)) {
    //   formErrors.value.discount_price = '折扣價不可高於原價'
    // }
    form.value.product_variants.forEach((variant) => {
    // 確保值是數字（並移除可能的逗號）
    const originalPrice = parseFloat((variant.original_price || '0').toString().replace(/,/g, ''))
    const discountPrice = parseFloat((variant.discount_price || '0').toString().replace(/,/g, ''))

    if (!originalPrice || isNaN(originalPrice)) {
      formErrors.value.original_price = '請輸入原價'
    }
    if (!discountPrice || isNaN(discountPrice)) {
       formErrors.value.discount_price = '請輸入折扣價'
    }
    if (originalPrice < discountPrice) {
       formErrors.value.discount_price = '折扣價不可高於原價'
    }
  })

    if (Object.keys(formErrors.value).length > 0) {
      errorMsg.value = '請檢查表單欄位是否輸入正確！';
      return
    }
    const res = await axios.post('/api/admin/createOrUpdateProduct', form.value)
      if (res.data.success) {
        errorMsg.value = res.data.message || '新增或更新成功'
        Swal.fire('成功', errorMsg.value, 'success')
        loadProducts()
        closeModal()
      } else {
        errorMsg.value = res.data.message || '新增或更新失敗'
        Swal.fire('錯誤', errorMsg.value, 'error')
     }
  } catch (error) {
    console.error('儲存商品失敗', error)
  }
}

// 更新商品上下架狀態
async function updateIsActive(product) {
  // 1. product 的 is_active 已在 v-model 改為 0 或 1
  // 2. 呼叫後端更新 API
  try {
    const payload = {
      product_id: product.product_id,
      is_active: product.is_active
    }
    const res = await axios.put(`/api/admin/products/isActive`, payload)
    // 假設後端路由 /api/admin/products/:id/isActive 用 PUT 來更新啟用 / 停用
    // 後端根據 product_id 找到商品並 set is_active = payload.is_active
    
    if (res.data.success) {
      console.log('更新成功', res.data.message)
    } else {
      // 如果失敗，可能要回退畫面上的狀態
      alert(res.data.message || '更新失敗')
      // 回退前端 v-model 的 is_active
      product.is_active = product.is_active === 1 ? 0 : 1
    }
  } catch (error) {
    console.error('更新上下架失敗', error)
    // 同樣回退
    product.is_active = product.is_active === 1 ? 0 : 1
  }
}


// ...

// 如果你想針對「即將離開這個路由」的情況：
onBeforeRouteLeave((to, from, next) => {
  // 這裡把 overflow 重設為 ''
  document.body.style.overflow = ''
  next()
})

// 如果你使用 Composition API + <script setup> 沒有 onBeforeRouteLeave
// 可以改成 router.afterEach 這種全域寫法，也能達到類似效果

onBeforeUnmount(() => {
  // 假如這個頁面會在組件卸載前做最後收尾，也可加一行：
  document.body.style.overflow = ''
})

// 取得商品類別名稱
function getProductTypeName(productTypeId) {
  const type = product_types.value.find(type => type.id === productTypeId)
  return type ? type.type_name : '未知類別'
}

function openCategoryModal() {
  showCategoryModal.value = true
}

function closeCategoryModal() {
  showCategoryModal.value = false
  categoryForm.value = { id: null, type_name: '', is_active: 1 }
}

function editCategory(cat) {
  categoryForm.value = { ...cat }
}

async function removeCategory(category) {
  Swal.fire({
    title: `確定要刪除「${category.type_name}」嗎？`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: '確定',
    cancelButtonText: '取消'
  }).then(async (result) => {
    if (result.isConfirmed) {
      const res = await axios.delete(`/api/admin/product-types/${category.id}`)
      if (res.data.success) {
        fetchCategories(null, category.id, "DELETE")
      }
    }
  })
}

async function saveCategory() {
  if (categoryForm.value.id) {
    const res = await axios.put(`/api/admin/product-types/${categoryForm.value.id}`, categoryForm.value)
    if (res.data.success) {
      fetchCategories(categoryForm, categoryForm.value.id, "UPDATE")
      Swal.fire('成功', res.data.message, 'success')
    }
  } else {
    if (!categoryForm.value.type_name) {
      Swal.fire('請輸入類別名稱')
      return
    }
    const res = await axios.post('/api/admin/product-types', categoryForm.value)
    if (res.data.success) {
      Swal.fire('成功', res.data.message, 'success')
      fetchCategories(categoryForm, res.data.newid, "ADD")
    }
  }
}

function fetchCategories(categoryForm, id, action) {
  switch (action) {
    case "ADD":
      product_types.value.push({
        id,
        type_name: categoryForm.value.type_name,
        is_active: categoryForm.value.is_active
      })
      break
    case "UPDATE":
      product_types.value = product_types.value.map(item => {
        if (item.id === id) {
          return {
            ...item,
            type_name: categoryForm.value.type_name,
            is_active: categoryForm.value.is_active
          }
        }
        return item
      })
      break
    case "DELETE":
      product_types.value = product_types.value.filter(item => item.id !== id)
      break
  }
}

onBeforeMount(async () => {
  await useAdminSysTemp.fetchAdminCheckLogin()
  if (!useAdminSysTemp.isLoggedIn) {
    router.push('/admin/login')
    return
  }

  await useAdminSysTemp.fetchProductTypesData()
  product_types.value = useAdminSysTemp.product_types
  await loadProducts();
})

onMounted(() => {
  window.addEventListener('keydown', handleEscape)
})

onBeforeUnmount(() => {
  window.removeEventListener('keydown', handleEscape)
})

async function loadProducts() {
  try {
    // 從 currentPage、limit、offset 等組裝參數傳給後端
    offset.value = (currentPage.value - 1) * limit.value
    const res = await axios.post('/api/admin/productslist', {
      limit: limit.value,
      offset: offset.value,
      searchKeyword: searchKeyword.value,
      product_type: selectedProductType.value
    })
    // 假設後端會回傳： { success: true, products, total }
    if (res.data.success) {
      products.value = res.data.products
      total.value = res.data.total
      // 計算總頁數
      totalPages.value = Math.ceil(total.value / limit.value)
    }
  } catch (error) {
    console.error('載入商品失敗', error)
  }
}


function prevPage() {
  if (currentPage.value > 1) {
    currentPage.value--
    loadProducts() // 重新呼叫載入
  }
}

function nextPage() {
  if (currentPage.value < totalPages.value) {
    currentPage.value++
    loadProducts() // 重新呼叫載入
  }
}


function handleSearch() {
  currentPage.value = 1
  loadProducts()
}

function editProduct(product) {
  errorMsg.value = ''
  currentEditProduct.value = product
  form.value = { ...product }
  showModal.value = true
}

// 刪除商品
async function deleteProduct(productId) {
  Swal.fire({
    title: '確定要刪除此商品嗎？',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: '確定',
    cancelButtonText: '取消'
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        const res = await axios.delete(`/api/admin/products/${productId}`)
        if (res.data.success) {
          Swal.fire('成功', res.data.message, 'success')
          loadProducts()
        } else {
          Swal.fire('錯誤', res.data.message, 'error')
        }
      } catch (error) {
        console.error('刪除商品失敗', error)
      }
    }
  })
}

function addMedia() {
  form.value.product_media.push({
    media_url: '',
    ordering: 0,
    is_active: 1
  })
}

function removeMedia(idx) {
  form.value.product_media.splice(idx, 1)
}

function addVariant() {
  form.value.product_variants.push({
    variant_name: '',
    quantity: 0,
    original_price: 999999,
    discount_price: 9999
  })
}

function removeVariant(idx) {
  form.value.product_variants.splice(idx, 1)
}

function openNewProductModal() {
  currentEditProduct.value = null
  form.value = {
    product_id: null,
    product_type: '',
    unit: '',
    title: '',
    description: '',
    image_url: '',
    views_count: 0,
    stock: 0,
    sold_quantity: 0,
    is_new: 1,
    is_hot: 0,
    is_manager: 0,
    is_active: 1,
    product_media: [],
    product_variants: [],
    seo_description: '' 
  }
  showModal.value = true
}

function closeModal() {
  showModal.value = false
}

function handleEscape(event) {
  if (event.key === 'Escape') {
    closeModal()
  }
}

function isYouTubeURL(url) {
  if (!url) return false
  const lowerUrl = url.toLowerCase()
  // 最簡單判斷: 是否含 youtube.com/watch 或 youtu.be/
  return (
    lowerUrl.includes('youtube.com/watch') ||
    lowerUrl.includes('youtu.be/')
  )
}

function getYouTubeEmbedURL(url) {
  if (!url) return ''
  // 先處理 youtu.be/xxxx
  if (url.includes('youtu.be/')) {
    const splitted = url.split('youtu.be/')
    return 'https://www.youtube.com/embed/' + splitted[1]
  }
  // 再處理 youtube.com/watch?v=xxxx
  if (url.includes('watch?v=')) {
    const splitted = url.split('watch?v=')
    const videoId = splitted[1].split('&')[0]
    return 'https://www.youtube.com/embed/' + videoId
  }
  // 其他狀況就原樣回傳
  return url
}

// 新增的 editHtml 方法
function editHtml(product_id) {
  if(!product_id){
    return
  }
  // 手機板不支援 window.open
  if (window.innerWidth > 768) {
    const url = `/editor/?edittype=product&product_id=${product_id}`
    window.open(url, '_blank', 'width=1830,height=1200,scrollbars=yes,resizable=yes')
  }else{
    Swal.fire('手機板不支援編輯 HTML')
  }

}

</script>



  
  <style scoped>
  .admin-products{
    background-color: #fafafa;
    padding: 1rem;
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

  }
  /* 篩選區塊 */
  .filter-section {
    margin-bottom: 1rem;
    display: flex;
    gap: 0.5rem;
  }
  
  /* 列表 Table */
  table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 1rem;
  }
  
  th, td {
    border: 1px solid #ccc;
    padding: 0.5rem;
    text-align: left;
  }

  /* Modal 背景 */
  .modal-backdrop {
    position: fixed;
    top: 0; left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.3);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  /* Modal 本體 */
  .modal {
    background: #fff;
    padding: 1.5rem;
   /* width: 400px;*/
    max-height: 80vh;
    overflow-y: auto;
    border-radius: 4px;
    box-shadow: 0 4px 10px rgba(0,0,0,0.1);
  }
  
  .form-group {
    margin-bottom: 1rem;
    display: flex;
    flex-direction: column;
  }
  
  .modal-actions {
    display: flex;
    gap: 1rem;
    justify-content: flex-end;
    margin-top: 1rem;
  }
  </style>
  <style scoped>
  /* 給類別管理的 Modal 加點寬度、留白 */
/* .category-modal {
  width: 600px;
  max-width: 90%;
} */

.modal.category-modal {
  /* 或者你的 class 名稱是 .category-modal */
  width: 600px;           /* 依實際需求 */
  max-height: 80vh;       /* 讓最高不超過視窗 80% 高度 */
  overflow-y: auto;       /* 超過時垂直捲動 */
  box-sizing: border-box; /* 建議加上，以免 padding 影響計算 */
}


/* 簡易提示文字 */
.category-hint {
  margin: 0.5rem 0 1rem;
  font-size: 0.9rem;
  color: #666;
}

/* Table 樣式，可與主程式 table 共享 */
.category-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1rem;
}

.category-table th,
.category-table td {
  border: 1px solid #ccc;
  padding: 0.5rem;
  text-align: left;
}

/* 分隔線 */
.divider {
  margin: 1rem 0;
  border: none;
  border-top: 1px solid #ddd;
}

/* Badge 樣式 */
.badge {
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  color: #fff;
  font-size: 0.8rem;
}
.badge-active {
  background-color: #2ecc71; /* 綠色 */
}
.badge-inactive {
  background-color: #e74c3c; /* 紅色 */
}

/* form-group 讓每一組表單元素之間保持一些間距 */
.form-group {
  margin-bottom: 1rem;
}

/* 讓 checkbox 與文字在同一列，並可一起被點擊 */
.check-group .checkbox-label {
  display: inline-flex; /* 讓input + span排在同一列 */
  align-items: center;  /* 垂直置中 */
  cursor: pointer;      /* 滑鼠變成指標，可點擊 */
  gap: 8px;            /* checkbox 與文字之間的距離 */
}

/* 微調 checkbox 與文字之間的距離 */
.check-group input[type="checkbox"] {
  margin-right: 0.5rem;
}

/* 文字樣式可自行調整 */
.check-label {
  font-size: 1.2rem;
  color: #333;
}

/* 若需要 hover 效果 */
.check-group .checkbox-label:hover .check-label {
  text-decoration: underline;
}

  </style>
  <style scoped>

  .modal-actions button {
    background-color: #2e3a59;
    color: #fff;
    border: none;
    padding: 0.5rem 1rem;
    cursor: pointer;
    border-radius: 4px;
    margin-right: 0.5rem;
  }
  
  .modal-actions button:hover {
    background-color: #3b4b6b;
  }

  .filter-section button {
    padding: 0.5rem 1rem;
    background-color: #2e3a59;
    color: #fff;
    border: none;
    cursor: pointer;
    border-radius: 4px;
    transition: background-color 0.2s;
  }

  .filter-section button:hover {
    background-color: #3b4b6b;
  }

  .category-table button {

    padding: 0.3rem 0.5rem;
    background-color: #2e3a59;
    color: #fff;
    border: none;
    cursor: pointer;
    border-radius: 4px;
    transition: background-color 0.2s;
    margin: 0 0.3rem;
  }

  .category-table button:hover {
    background-color: #3b4b6b;
  } 


  .products-table button {
    padding: 0.3rem 0.5rem;
    background-color: #2e3a59;
    color: #fff;
    border: none;
    cursor: pointer;
    border-radius: 4px;
    transition: background-color 0.2s;
    margin: 0 0.3rem;
  }

  .products-table button:hover {
    background-color: #3b4b6b;
  }

  /* 假設已繼承你原本的 .modal, .form-group 樣式 */

.product-modal {
  width: 80%;
  max-width: 1200px; /* 超過 1200px 時就不會再放大 */
  max-height: 90vh;
  overflow-y: auto;
}

.product-basic-info {
  /* 基本資訊區域，可自訂樣式 */
}

/* 媒體區塊, 規格區塊 */
.product-media, .product-variants {
  flex: 1;
  min-width: 0; /* 讓內容不擠爆 */
}

.product-media table,
.product-variants table {
  width: 100%;
  border-collapse: collapse;
}

.product-media table th,
.product-media table td,
.product-variants table th,
.product-variants table td {
  border: 1px solid #ccc;
  padding: 0.5rem;
}

/* 新增按鈕 */
.add-btn {
  margin-top: 0.5rem;
  background-color: #2e3a59;
  color: #fff;
  padding: 0.3rem 0.6rem;
  border: none;
  cursor: pointer;
  border-radius: 4px;
}

/* 小提示 */
.hint {
  font-size: 0.85rem;
  color: #666;
  margin-bottom: 0.5rem;
}


.multi-fields {
  display: flex;      /* 啟用 Flex 排列 */
  gap: 1rem;          /* 欄位間距 (也可用 margin ) */
  align-items: flex-start; /* 讓三個欄位的頂部對齊 */
}

.sub-field {
  flex: 1;            /* 讓三個子欄位等比例分攤可用空間 */
  display: flex;
  flex-direction: column; /* label 和 input/textarea 垂直排列 */
}



.sub-field select:hover {
  border-color: #999;
}
.sub-field select:focus {
  border-color: #666;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
}

.sub-field select {
  
  font-size: 1.1rem;
  padding: 0.5rem 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  transition: border-color 0.2s;
}

.two-cols {
  display: flex;
  justify-content: space-between;
  gap: 1rem; /* 添加間距 */
}

.two-cols .sub-field {
  flex: 1;
  margin-right: 1rem;
}

.two-cols .sub-field:last-child {
  margin-right: 0;
}

/* 讓 checkbox-list (左邊) 與 image-preview (右邊) 並排 */
.check-group {
  display: flex; 
  gap: 1rem; /* 左右之間的空白 */
}

/* 左邊那塊 */
.checkbox-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem; /* 每個 checkbox 的間距 */
}

/* 右邊預覽區塊 */
.image-preview {
  /* 讓圖片不至於過大，可自行調整 */
  max-width: 200px;
  max-height: 200px;
  overflow: hidden;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.image-preview img {
  width: 100%;
  height: auto;
  display: block; /* 移除img預設的行內間隙 */
}

.table-scroll {
  width: 100%;           /* 或直接改成 max-width: 100%; */
  max-width: 100%;       /* 確保不超出父容器 */
  overflow-x: auto;      /* 超出就可以水平捲動 */
  margin-bottom: 1rem;
  -webkit-overflow-scrolling: touch; /* iOS 慣性捲動 */
}

/* 讓 table-layout: fixed; 也可在必要時使用 */
.product-variants table {
  table-layout: auto;  /* 或 fixed; 視情況 */
  width: 100%;         /* 通常還是讓它 100% */
  border-collapse: collapse;
}

.table-scroll input[type="number"],
.table-scroll input[type="text"] {
  width: 100%;
  /* 或者先移除這段，讓它根據父容器自動縮放 */
  box-sizing: border-box;
}

/* 手機以下 (max-width: 768px) 時，輸入框改成自動寬度 */
@media (max-width: 768px) {
  .table-scroll input[type="number"],
  .table-scroll input[type="text"] {
    width: auto; /* 或 100% 看你想要的效果 */
  }
}

@media (max-width: 768px) {
  .table-scroll table,
  .table-scroll thead,
  .table-scroll tbody,
  .table-scroll th,
  .table-scroll td,
  .table-scroll tr {
    display: block; /* 全部區塊化 */
    width: 100%;
  }
  .table-scroll tr {
    margin-bottom: 1rem; /* 讓每筆規格之間有點間距 */
  }
  .table-scroll th {
    font-weight: bold;
    margin-bottom: 0.3rem;
  }
  /* 也可視需要把表頭藏起來、再用 before/after 標示欄位名稱 */
}




.media-url-input {
  width: 100%;  /* 填滿該欄 */
  box-sizing: border-box;
}

.table-scroll input[type="number"] {
  width: 150px;
  box-sizing: border-box;
}


.filter-section select {
  font-size: 1.1rem;
  padding: 0.5rem 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  transition: border-color 0.2s;
}

.filter-section select:hover {
  border-color: #999;
}

.filter-section select:focus {
  outline: none;
  border-color: #666;
  box-shadow: 0 0 0 2px rgba(0,0,0,0.1);
}

.switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 22px;
    margin-left: 8px;
    vertical-align: middle;
  }
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0; left: 0; right: 0; bottom: 0;
    background-color: #ccc;
    transition: .4s;
    border-radius: 34px;
  }
  .slider:before {
    position: absolute;
    content: "";
    height: 16px; width: 16px;
    left: 3px; bottom: 3px;
    background-color: white;
    transition: .4s;
    border-radius: 50%;
  }
  input:checked + .slider {
    background-color: #2196F3;
  }
  input:checked + .slider:before {
    transform: translateX(18px);
  }

  .is-invalid {
    border-color: red !important;
}

.field-error {
    color: red;
    font-size: 0.85rem;
}

.radio-group.is-invalid {
    border: 1px solid red;
    /* 或 outline: 2px solid red */
    padding: 10px;
    /* 給一點內邊距，否則看不出框 */
    border-radius: 6px;
}

.error-message {
  color: red;
  font-size: 1.50rem;
}


/* 讓表格在手機版可左右滑動 */
.table-responsive {
    position: relative;
    width: 100%;
    overflow-x: auto;
    /* 可水平捲動 */
    -webkit-overflow-scrolling: touch;
}

/* 表格寬度比手機寬 */
.products-table {
    min-width: 1200px;
    border-collapse: collapse;
    margin-bottom: 1rem;
    width: 100%;
}

.products-table th,
.products-table td {
    border: 1px solid #ccc;
    padding: 0.5rem 0.75rem;
    text-align: center;
    font-size: 18px;
}
.media-preview-list {
  display: flex;
  flex-wrap: wrap;  /* 空間不夠就換行 */
  gap: 1rem;
  margin-top: 1rem; /* 這裡設定上方間距 */
}

/* 每個預覽塊統一寬度在電腦可能橫著擺 */
.media-preview-item {
  width: 300px;
  box-sizing: border-box;
}


/* 分頁區域 */
.pagination {
    display: flex;
    align-items: center;
    gap: 1rem;
    justify-content: center;
}

.pagination button {
    background-color: #2e3a59;
    color: #fff;
    border: none;
    padding: 0.4rem 1rem;
    cursor: pointer;
    border-radius: 4px;
    font-size: 16px;
}


/* RWD: 手機版 (小於 768px) 就改成上下分佈 */
@media (max-width: 768px) {

  .filter-section select {
    width: 100%;
    min-width: 150px;   /* 保證寬度 */
  }


  .filter-section {
    flex-direction: column; /* 從 row 改為 column */
    align-items: stretch;   /* 讓每一列的寬度都可以拉到 100% */
  }

  /* 如果想讓按鈕也佔滿 100% 寬度： */
  .filter-section button {
    width: 100%;
  }

  /* 讓表格在手機版可左右滑動 */
  .table-responsive {
      max-width: 310px;
  }

  .products-table th,
  .products-table td {
      font-size: 14px;
      padding: 0.4rem;
  }

  
  .product-modal {
    width: 95%;
    max-width: 95%;
  }

  .multi-fields {
    flex-direction: column; 
  }

  .two-cols {
    flex-direction: column;
  }

  .multi-fields .sub-field:last-child textarea {
    min-width: 300px;
  }

  .media-preview-item {
    width: 100%; /* 手機版改成 100% */
  }
    /* iframe 也自適應寬度 */
    .media-preview-item iframe {
    width: 100% !important; 
    height: auto; /* 依照寬高比自適應 */
  }
}

/* 針對桌面版(寬度>768px)什麼都不用特別改，維持表格樣式 */

/* 針對小螢幕：把 thead 隱藏、td block 化 */
@media (max-width: 768px) {
  .product-variants-table thead {
    display: none; /* 隱藏表頭 */
  }
  .product-variants-table tr,
  .product-variants-table td {
    display: block;       /* 讓每個 <td> 占一行 */
    width: 100%;          /* 撐滿容器 */
  }
  .product-variants-table td {
    margin-bottom: 1rem;  /* 每個欄位之間留一點距離 */
    position: relative;   /* 讓 ::before 能定位 */
  }

  /* 使用 ::before 顯示 data-label 的內容做為欄位標題 */
  .product-variants-table td::before {
    content: attr(data-label) "：";
    font-weight: bold;
    display: inline-block;
    margin-right: 0.5rem;  /* 標題與輸入框之間的空隙 */
  }
}
@media (max-width: 768px) {
  /* 1) 隱藏表頭 */
  .media-table thead {
    display: none;
  }

  /* 2) 讓每個 <tr>、<td> 變成區塊 (block) */
  .media-table tr,
  .media-table td {
    display: block;
    width: 100%; 
  }

  /* 3) 每筆資料之間的間距 */
  .media-table tr {
    margin-bottom: 1rem;
  }

  .media-table td {
    position: relative; 
    margin-bottom: 0.5rem;
  }

  .media-table td::before {
    content: attr(data-label) "：";
    font-weight: bold;
    display: inline-flex;
    align-items: center;
    margin-right: 0.5rem;
  }
}

  </style>